import { Pipe, PipeTransform } from '@angular/core';
import { EnvVariables } from '../../environments/environment';
import * as _ from 'lodash';
/**
 * Generated class for the FormatJobImgPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'weatherConditions',
})
export class WeatherConditionsPipe implements PipeTransform {
  constructor(public env: EnvVariables) {}
  /**
   * Takes a imgUrl from a job and creats an img src for the google map on a job
   */
  transform(conditions: any[], ...args) {
    _.each(conditions, item => {
      const id = _.get(item, 'id'),
        firstDigit = String(id)[0],
        lookup = {
          6: 100, // snow
          2: 200, // thunderstorm
          5: 300, // rain
          3: 400, // drizzle
          7: 500, // atmosphere
          8: 600, // clear/clouds
        };

      item['severity'] =
        (lookup[firstDigit] || 600) +
        (99 - parseFloat(String(id).slice(1)));
    });


    const currentCondition = _.minBy(conditions, function(c) { return c.severity; });;

    if (args[0] === 'icon') {
      return _.get(currentCondition, 'icon') || '-';
    } else if (args[0] === 'main') {
      return _.get(currentCondition, 'main') || '-';
    } else if (args[0] === 'description') {
      return _.get(currentCondition, 'description') || '-';
    } else {
      return '-'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/weather-conditions/weather-conditions.ts